import {getEnv} from "../helpers/EnvHelpers"

export const API_BASE_URL = getEnv("REACT_APP_API_BASE_URL")
export const API_BASE_URL_AUTH = "https://evax-cc-epharma-apis-staging2.infinitymgt.fr"
export const API_BACK_OFFICE_URL = getEnv("REACT_APP_BACK_OFFICE_API_BASE_URL")
export const API_EXTERNAL_URL = getEnv("REACT_APP_API_EXTERNAL_URL")
export const RECAPCHA_SITE_KEY = getEnv("REACT_APP_RECAPCHA_SITE_KEY")

export const SESSION_COOKIE_NAME = "sessionid-evax"
export const CLIENT_ID = getEnv("REACT_APP_CLIENT_ID")
export const DMSU_REDIRECT_URL = getEnv("REACT_APP_DMSU_REDIRECT_URL")
// export const API_BACK_BASE_URL = getEnv("REACT_APP_API_BACK_BASE_URL")

export const CALL_API = "middleware@CALL_API"

// Superset API endpoints
export const SUPERSET_TOKEN = "/api/dashboard/get_token/"

export const HTTP_METHODS = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  PATCH: "PATCH",
  DELETE: "DELETE"
}
